module.exports = __webpack_public_path__ + "img/blt-close02.be41d555.svg";